import { c as _c } from "react/compiler-runtime";
import { ExtendedDrop } from "@/helpers/waves/drop.helpers";
import { ApiDrop } from "@/generated/models/ApiDrop";
import WaveDropContent from "../WaveDropContent";
interface ParticipationDropContentProps {
  readonly drop: ExtendedDrop;
  readonly activePartIndex: number;
  readonly setActivePartIndex: (index: number) => void;
  readonly onLongPress: () => void;
  readonly onDropContentClick?: ((drop: ExtendedDrop) => void) | undefined;
  readonly onQuoteClick: (drop: ApiDrop) => void;
  readonly setLongPressTriggered: (triggered: boolean) => void;
  readonly isCompetitionDrop?: boolean | undefined;
}
export default function ParticipationDropContent(t0) {
  const $ = _c(9);
  const {
    drop,
    activePartIndex,
    setActivePartIndex,
    onLongPress,
    onDropContentClick,
    onQuoteClick,
    setLongPressTriggered,
    isCompetitionDrop: t1
  } = t0;
  const isCompetitionDrop = t1 === undefined ? false : t1;
  let t2;
  if ($[0] !== activePartIndex || $[1] !== drop || $[2] !== isCompetitionDrop || $[3] !== onDropContentClick || $[4] !== onLongPress || $[5] !== onQuoteClick || $[6] !== setActivePartIndex || $[7] !== setLongPressTriggered) {
    t2 = <div className="tw-mt-1"><WaveDropContent drop={drop} activePartIndex={activePartIndex} setActivePartIndex={setActivePartIndex} onLongPress={onLongPress} onDropContentClick={onDropContentClick} onQuoteClick={onQuoteClick} setLongPressTriggered={setLongPressTriggered} isCompetitionDrop={isCompetitionDrop} /></div>;
    $[0] = activePartIndex;
    $[1] = drop;
    $[2] = isCompetitionDrop;
    $[3] = onDropContentClick;
    $[4] = onLongPress;
    $[5] = onQuoteClick;
    $[6] = setActivePartIndex;
    $[7] = setLongPressTriggered;
    $[8] = t2;
  } else {
    t2 = $[8];
  }
  return t2;
}